/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ESearchCctType {
    ALL = 'ALL',
    CC = 'CC',
    ARE = 'ARE'
}


export function ESearchCctTypeFromJSON(json: any): ESearchCctType {
    return ESearchCctTypeFromJSONTyped(json, false);
}

export function ESearchCctTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ESearchCctType {
    return json as ESearchCctType;
}

export function ESearchCctTypeToJSON(value?: ESearchCctType | null): any {
    return value as any;
}

